<form class="popupForm" style="min-height: 200px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <ng-container *ngIf="state == 'default'">Send message</ng-container>
      <ng-container *ngIf="state == 'comment'">Save comment</ng-container>
      <ng-container *ngIf="state == 'description'">Edit description</ng-container>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display:flex !important; min-height: 200px; padding-top: 20px;">

      <mat-form-field appearance="outline" color="accent" style="width: 100%">
        <mat-label>Message text</mat-label>
        <textarea matInput formControlName="messageControl"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="{{5}}"
                  cdkAutosizeMaxRows="{{10}}"></textarea>
      </mat-form-field>
<!--        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"-->
<!--             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['textValue']">-->
<!--          <mat-icon color="warn">error</mat-icon><span>{{ validationResult.messagesPerControls['textValue']}}</span>-->
<!--        </div>-->

    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="sendAndClose()">
        <ng-container *ngIf="state == 'default'">Send</ng-container>
        <ng-container *ngIf="state == 'comment'">Save</ng-container>
        <ng-container *ngIf="state == 'description'">Save</ng-container>
      </button>
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
    </div>
  </div>
</form>
